/* TEWIKY Cart Drawer V0.7 — Horizon Native Port
   - Market-safe $49 shipping-goal helper
   - Bridge for legacy/custom AJAX add flows (Homepage + PDP) into Horizon cart events
   - Complete the Look recommendations + variant controls
*/
(function(){
  if(window.__TWK_CART_DRAWER_V02__) return;
  window.__TWK_CART_DRAWER_V02__=true;

  function rootUrl(){
    var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    return root.endsWith('/')?root:(root+'/');
  }

  function money(minor,currency){
    try{return new Intl.NumberFormat(undefined,{style:'currency',currency:currency,maximumFractionDigits:2}).format(Number(minor||0)/100);}
    catch(e){return ((Number(minor||0)/100).toFixed(2)+' '+currency);}
  }

  /* ---------- Shared motion: product -> header cart + count boost ---------- */
  function isVisibleElement(el){
    if(!el||!el.getBoundingClientRect)return false;
    var rect=el.getBoundingClientRect();
    if(rect.width<2||rect.height<2)return false;
    var style=window.getComputedStyle?window.getComputedStyle(el):null;
    return !style||((style.display!=='none')&&(style.visibility!=='hidden')&&(Number(style.opacity||1)>0));
  }

  function getCartMotionTarget(){
    var selectors=[
      '.twk-cart-action cart-icon',
      '.twk-cart-action [data-testid="cart-icon"]',
      '[data-testid="cart-drawer-trigger"] cart-icon',
      '.header-actions__cart-icon',
      'cart-icon[data-testid="cart-icon"]'
    ];
    for(var i=0;i<selectors.length;i++){
      var nodes=document.querySelectorAll(selectors[i]);
      for(var j=0;j<nodes.length;j++)if(isVisibleElement(nodes[j]))return nodes[j];
    }
    return null;
  }

  function elementImageUrl(image){
    if(!image)return '';
    if(typeof image==='string')return image;
    if(image.currentSrc)return image.currentSrc;
    if(image.src)return image.src;
    try{
      var bg=window.getComputedStyle(image).backgroundImage||'';
      var match=bg.match(/url\(["']?(.*?)["']?\)/i);
      if(match&&match[1])return match[1];
    }catch(error){}
    return '';
  }

  function flyToCart(options){
    options=options||{};
    if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return 0;
    var target=options.target||getCartMotionTarget();
    var source=options.source||options.image;
    var image=options.image||source;
    if(!target||!source||!source.getBoundingClientRect)return 0;

    var sourceRect=source.getBoundingClientRect();
    var targetRect=target.getBoundingClientRect();
    if(sourceRect.width<2||sourceRect.height<2||targetRect.width<2||targetRect.height<2)return 0;

    var imageUrl=options.imageUrl||elementImageUrl(image);
    if(!imageUrl)return 0;

    var startSize=Math.max(56,Math.min(86,Math.min(sourceRect.width,sourceRect.height)||72));
    var startLeft=sourceRect.left+(sourceRect.width-startSize)/2;
    var startTop=sourceRect.top+(sourceRect.height-startSize)/2;
    var endX=targetRect.left+targetRect.width/2-(startLeft+startSize/2);
    var endY=targetRect.top+targetRect.height/2-(startTop+startSize/2);
    var lift=Math.max(54,Math.min(118,Math.abs(endY)*.22+42));
    var duration=Number(options.duration||560);

    function createLayer(isGhost,delay){
      var node=document.createElement('img');
      node.className='twk-cart-fly'+(isGhost?' twk-cart-fly--ghost':'');
      node.src=imageUrl;
      node.alt='';
      node.setAttribute('aria-hidden','true');
      node.style.left=startLeft+'px';
      node.style.top=startTop+'px';
      node.style.width=startSize+'px';
      node.style.height=startSize+'px';
      node.style.setProperty('--twk-fly-size',startSize+'px');
      node.style.opacity=isGhost?'.24':'1';
      document.body.appendChild(node);
      var animation=node.animate([
        {transform:'translate3d(0,0,0) rotate(0deg) scale(1)',opacity:isGhost?.22:1,offset:0},
        {transform:'translate3d('+(endX*.45).toFixed(1)+'px,'+((endY*.42)-lift).toFixed(1)+'px,0) rotate(-5deg) scale(.76)',opacity:isGhost?.16:.96,offset:.46},
        {transform:'translate3d('+(endX*.78).toFixed(1)+'px,'+((endY*.76)-(lift*.38)).toFixed(1)+'px,0) rotate(3deg) scale(.46)',opacity:isGhost?.10:.92,offset:.76},
        {transform:'translate3d('+endX.toFixed(1)+'px,'+endY.toFixed(1)+'px,0) rotate(0deg) scale(.18)',opacity:isGhost?0:.82,offset:1}
      ],{
        duration:isGhost?duration-40:duration,
        delay:delay||0,
        easing:'cubic-bezier(.18,.72,.18,1)',
        fill:'forwards'
      });
      animation.finished.catch(function(){}).finally(function(){node.remove();});
      return animation;
    }

    createLayer(true,48);
    var main=createLayer(false,0);
    main.finished.catch(function(){}).finally(function(){
      target.classList.remove('twk-cart-target-pulse');
      void target.offsetWidth;
      target.classList.add('twk-cart-target-pulse');
      window.setTimeout(function(){target.classList.remove('twk-cart-target-pulse');},380);
    });
    return duration;
  }

  window.TewikyCartMotion=window.TewikyCartMotion||{};
  window.TewikyCartMotion.flyToCart=flyToCart;
  window.TewikyCartMotion.getTarget=getCartMotionTarget;

  var lastDrawerBadgeCount=null;
  var badgeAnimationTimer=0;
  function animateCartBadgeIfChanged(){
    var badge=document.querySelector('#cart-drawer [data-twk-cart-badge], #cart-drawer .theme-drawer__badge');
    if(!badge){if(lastDrawerBadgeCount===null)lastDrawerBadgeCount=0;return;}
    var raw=badge.dataset.twkCartCount||badge.textContent||'';
    var count=parseInt(String(raw).replace(/[^0-9]/g,''),10);
    if(!Number.isFinite(count))return;
    if(lastDrawerBadgeCount===null){lastDrawerBadgeCount=count;return;}
    if(count===lastDrawerBadgeCount)return;
    var previous=lastDrawerBadgeCount;
    lastDrawerBadgeCount=count;
    badge.classList.remove('twk-cart-count-bump','twk-cart-count-bump--down');
    void badge.offsetWidth;
    badge.classList.add('twk-cart-count-bump');
    if(count<previous)badge.classList.add('twk-cart-count-bump--down');
    clearTimeout(badgeAnimationTimer);
    badgeAnimationTimer=window.setTimeout(function(){
      badge.classList.remove('twk-cart-count-bump','twk-cart-count-bump--down');
    },460);
  }

  function updateGoal(root){
    root=root||document;
    root.querySelectorAll('[data-twk-shipping-goal]').forEach(function(goal){
      var base=Number(goal.dataset.baseThreshold||4900);
      var total=Number(goal.dataset.cartDiscountedTotal||0);
      var shop=(goal.dataset.shopCurrency||'USD').toUpperCase();
      var cart=(goal.dataset.cartCurrency||shop).toUpperCase();
      var message=goal.querySelector('[data-twk-shipping-message]');
      var bar=goal.querySelector('[data-twk-shipping-bar]');
      if(!message||!bar)return;
      var threshold=base,reliable=true;
      if(cart!==shop){
        var rate=Number(window.Shopify&&Shopify.currency&&Shopify.currency.rate);
        if(Number.isFinite(rate)&&rate>0)threshold=Math.round(base*rate);else reliable=false;
      }
      if(!reliable){
        message.innerHTML='<strong>FREE SHIPPING</strong> available on qualifying orders';
        goal.style.setProperty('--twk-shipping-progress','0%');
        return;
      }
      var remaining=Math.max(0,threshold-total);
      var progress=threshold>0?Math.min(100,(total/threshold)*100):100;
      goal.style.setProperty('--twk-shipping-progress',progress.toFixed(2)+'%');
      if(remaining>0){
        message.innerHTML="You're <strong>"+money(remaining,cart)+"</strong> away from <strong>FREE SHIPPING</strong>";
      }else{
        message.innerHTML="You've unlocked <strong>FREE SHIPPING</strong> <span class=\"twk-shipping-progress__check\" aria-hidden=\"true\">✓</span>";
      }
    });
  }

  /* ---------- Legacy/custom AJAX add -> Horizon standard cart event bridge ---------- */
  var bridgeQueue=Promise.resolve();
  var lastLegacyDetail=null;
  var lastLegacyAt=0;

  async function fetchCart(){
    var response=await fetch(rootUrl()+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'},cache:'no-store'});
    if(!response.ok)throw new Error('Unable to refresh cart');
    return response.json();
  }

  /* ---------- TEWIKY analytics: actual cart drawer view ----------
     Shopify has a standard cart_viewed event for /cart, but TEWIKY primarily
     uses a Horizon AJAX drawer. Publish one custom event on each real closed ->
     open transition. Re-firing theme-drawer:open while already open is ignored. */
  var twkCartDrawerIsOpen=false;

  function publishShopifyAnalytics(eventName,payload){
    try{
      if(window.Shopify&&window.Shopify.analytics&&typeof window.Shopify.analytics.publish==='function'){
        window.Shopify.analytics.publish(eventName,payload||{});
      }
    }catch(error){
      console.warn('[TEWIKY Analytics] Publish failed',eventName,error);
    }
  }

  function cartAnalyticsItems(cart){
    return (cart&&Array.isArray(cart.items)?cart.items:[]).map(function(line){
      return {
        product_id:String(line.product_id||''),
        variant_id:String(line.variant_id||line.id||''),
        title:String(line.product_title||line.title||''),
        variant_title:String(line.variant_title||''),
        price_cents:Number(line.final_price||line.price||0),
        line_value_cents:Number(line.final_line_price||line.line_price||0),
        quantity:Number(line.quantity||1)
      };
    });
  }

  document.addEventListener('theme-drawer:open',function(event){
    var target=event&&event.target;
    var drawer=target&&target.closest?target.closest('theme-drawer#cart-drawer'):null;
    if(!drawer||twkCartDrawerIsOpen)return;
    twkCartDrawerIsOpen=true;

    fetchCart().then(function(cart){
      publishShopifyAnalytics('tewiky:cart_drawer_viewed',{
        currency:String(cart.currency||((window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD')),
        value_cents:Number(cart.total_price||0),
        item_count:Number(cart.item_count||0),
        items:cartAnalyticsItems(cart)
      });
    }).catch(function(error){
      console.warn('[TEWIKY Analytics] Cart drawer snapshot unavailable',error);
      publishShopifyAnalytics('tewiky:cart_drawer_viewed',{
        currency:String((window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD'),
        value_cents:0,
        item_count:null,
        items:[]
      });
    });
  });

  document.addEventListener('theme-drawer:close',function(event){
    var target=event&&event.target;
    var drawer=target&&target.closest?target.closest('theme-drawer#cart-drawer'):null;
    if(drawer)twkCartDrawerIsOpen=false;
  });

  function getCartSectionIds(){
    var ids=new Set();
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function(component){
      var id=String(component.dataset.sectionId||'').trim();
      if(id)ids.add(id);
    });
    ids.add('cart-drawer-section');
    return Array.from(ids);
  }

  async function fetchCartSections(){
    var ids=getCartSectionIds();
    if(!ids.length)return undefined;

    /* IMPORTANT: render the cart drawer in the CURRENT page context.
       cart-drawer.liquid intentionally does not render on template.name == 'cart',
       so using /cart as sections_url returns an empty cart-drawer-section. */
    var base=window.location.pathname+window.location.search;
    var url=new URL(base,window.location.origin);
    url.searchParams.set('sections',ids.join(','));
    url.searchParams.set('_twk',String(Date.now()));
    var response=await fetch(url.toString(),{
      credentials:'same-origin',
      headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},
      cache:'no-store'
    });
    if(!response.ok)throw new Error('Unable to refresh cart sections');
    var sections=await response.json();
    return sections&&typeof sections==='object'?sections:undefined;
  }

  function cartSnapshotFromSections(sections){
    try{
      var html=sections&&sections['cart-drawer-section'];
      if(!html)return null;
      var doc=new DOMParser().parseFromString(html,'text/html');
      var countNode=doc.querySelector('[ref="cartItemCount"]');
      var badge=doc.querySelector('.theme-drawer__badge');
      var countText=(countNode&&countNode.textContent)||(badge&&badge.textContent)||'';
      var count=parseInt(String(countText).replace(/[^0-9]/g,''),10);
      if(!Number.isFinite(count))count=0;
      return {
        item_count:count,
        total_price:0,
        currency:String((window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD')
      };
    }catch(error){
      return null;
    }
  }

  function syncCartCountFromSnapshot(cart){
    if(!cart||!Number.isFinite(Number(cart.item_count)))return;
    var count=Number(cart.item_count);
    document.querySelectorAll('[data-cart-count],[data-cart-item-count],[data-cart-count-bubble],.header__cart-count,.cart-count-number,.cart-count__number').forEach(function(el){
      if(el)el.textContent=String(count);
    });
  }

  function dispatchHorizonAdd(cart,meta){
    meta=meta||{};
    var event=new Event('shopify:cart:lines-update',{bubbles:true});
    event.action='add';
    event.context=meta.context||'product';
    event.lines=meta.lines||[];
    event.promise=Promise.resolve({
      cart:{
        totalQuantity:Number(cart.item_count||0),
        totalAmount:{amount:(Number(cart.total_price||0)/100).toFixed(2),currencyCode:String(cart.currency||'USD')}
      },
      detail:{
        didError:false,
        items:cart.items||[],
        itemCount:Number(cart.item_count||0),
        source:meta.source||'tewiky-custom-ajax-add',
        sourceId:meta.sourceId||'',
        sections:meta.sections||undefined
      }
    });
    document.dispatchEvent(event);
    return event.promise;
  }

  function nextPaint(){
    return new Promise(function(resolve){
      requestAnimationFrame(function(){requestAnimationFrame(resolve);});
    });
  }

  function ensureCartDrawerOpen(){
    var drawer=document.querySelector('theme-drawer#cart-drawer');
    if(!drawer||typeof drawer.open!=='function')return;
    /* Calling open() on an already-open Horizon modal briefly closes/reopens
       it to move it in the top layer. Never do that for a cart refresh. */
    var isOpen=drawer.hasAttribute('open')||drawer.isOpen===true;
    if(!isOpen)drawer.open();
  }

  async function performNotifyAdd(meta){
    meta=meta||{};
    try{
      var sections=meta.sections;
      var cart=meta.cart||null;

      /* FAST PATH: /cart/add.js already returned fresh cart-drawer HTML.
         Morph it immediately instead of blocking the drawer on an extra /cart.js
         round-trip. This is the main latency win for PDP/category/home adds. */
      if(sections&&sections['cart-drawer-section']){
        cart=cart||cartSnapshotFromSections(sections)||{item_count:0,total_price:0,currency:'USD'};
        await dispatchHorizonAdd(cart,Object.assign({},meta,{sections:sections}));
        await nextPaint();
        syncCartCountFromSnapshot(cart);
        updateGoal(document);
        if(meta.open!==false)ensureCartDrawerOpen();

        /* Reconcile full cart JSON in the background for quantity metadata and
           bundle thumbnails. Never make the visible drawer wait for it. */
        if(!meta.cart){
          fetchCart().then(function(fullCart){
            syncCartCountFromSnapshot(fullCart);
          }).catch(function(){});
        }
        return cart;
      }

      /* FALLBACK: if the caller did not provide rendered sections, fetch cart JSON
         and the drawer section concurrently rather than serially. */
      var results=await Promise.all([
        cart?Promise.resolve(cart):fetchCart(),
        fetchCartSections().catch(function(sectionError){
          console.warn('[TEWIKY Cart Bridge] Section refresh fallback failed.',sectionError);
          return undefined;
        })
      ]);
      cart=results[0];
      sections=results[1];

      await dispatchHorizonAdd(cart,Object.assign({},meta,{sections:sections}));
      await nextPaint();
      syncCartCountFromSnapshot(cart);
      updateGoal(document);
      if(meta.open!==false)ensureCartDrawerOpen();
      return cart;
    }catch(error){
      console.warn('[TEWIKY Cart Bridge] Unable to sync custom add-to-cart.',error);
      return null;
    }
  }

  function notifyAdd(meta){
    /* Serialize updates instead of dropping a second add while the first drawer morph
       is still finishing. This is critical for back-to-back $89 bundle purchases. */
    bridgeQueue=bridgeQueue.catch(function(){return null;}).then(function(){
      return performNotifyAdd(meta||{});
    });
    return bridgeQueue;
  }

  window.TewikyCartBridge={notifyAdd:notifyAdd,refreshGoal:function(){updateGoal(document);}};

  function onLegacyAdded(event){
    var now=Date.now();
    if(event&&event.detail&&event.detail===lastLegacyDetail&&now-lastLegacyAt<500)return;
    lastLegacyDetail=event&&event.detail||null;
    lastLegacyAt=now;
    var detail=event&&event.detail&&typeof event.detail==='object'?event.detail:{};
    notifyAdd({
      source:'twk:cart:added',
      sections:detail.sections||undefined,
      open:true
    });
  }
  document.addEventListener('twk:cart:added',onLegacyAdded);
  document.addEventListener('cart:update',function(event){
    var detail=event&&event.detail&&typeof event.detail==='object'?event.detail:{};
    notifyAdd({source:'tewiky-cart-update',sections:detail.sections||undefined,open:true});
  });

  function attachHomepageBridge(){
    var home=document.getElementById('twk-homepage');
    if(home&&!home.dataset.twkCartBridgeReady){
      home.dataset.twkCartBridgeReady='1';
      home.addEventListener('twk:cart:added',onLegacyAdded);
    }
  }

  /* ---------- Shared helpers ---------- */
  function escapeHtml(value){
    return String(value==null?'':value).replace(/[&<>'\"]/g,function(ch){return {'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','\"':'&quot;'}[ch];});
  }

  function normalizeImageUrl(value){
    if(!value)return '';
    if(typeof value==='string'){
      if(value.indexOf('//')===0)return window.location.protocol+value;
      return value;
    }
    if(typeof value==='object'){
      var candidate=value.url||value.src||value.image_url||value.imageUrl||value.featured_image||value.featuredImage||'';
      if(candidate&&typeof candidate==='object')return normalizeImageUrl(candidate);
      if(typeof candidate==='string')return normalizeImageUrl(candidate);
    }
    return '';
  }

  function bundleComponentImage(component){
    if(!component||typeof component!=='object')return '';
    var candidates=[
      component.image,
      component.featured_image,
      component.featuredImage,
      component.image_url,
      component.imageUrl,
      component.product&&component.product.featured_image,
      component.product&&component.product.featuredImage,
      component.variant&&component.variant.featured_image,
      component.variant&&component.variant.image
    ];
    for(var i=0;i<candidates.length;i++){
      var url=normalizeImageUrl(candidates[i]);
      if(url)return url;
    }
    return '';
  }

  function bundleThumbMarkup(component){
    var title=component&&component.title?String(component.title):'Jewelry piece';
    var image=bundleComponentImage(component);
    if(image){
      return '<img class="cart-items__bundle-thumb-image" src="'+escapeHtml(image)+'" loading="lazy" alt="'+escapeHtml(title)+'">';
    }
    return '<span class="cart-items__bundle-thumb-placeholder" aria-hidden="true"></span>';
  }

  async function hydrateBundleLines(){
    var rows=[].slice.call(document.querySelectorAll('#cart-drawer .twk-cart-line--bundle-parent[data-key]'));
    if(!rows.length)return;
    try{
      var cart=await fetchCart();
      var lineMap=new Map((Array.isArray(cart&&cart.items)?cart.items:[]).map(function(line){return [String(line&&line.key||''),line];}));
      rows.forEach(function(row){
        var line=lineMap.get(String(row.dataset.key||''));
        if(!line)return;
        var components=Array.isArray(line.item_components)?line.item_components:(Array.isArray(line.components)?line.components:[]);
        var cards=row.querySelectorAll('.cart-items__bundle-item');
        cards.forEach(function(card,index){
          var component=components[index];
          if(!component)return;
          var thumb=card.querySelector('[data-bundle-thumb]');
          if(thumb&&thumb.dataset.twkHydrated!=='1'){
            thumb.innerHTML=bundleThumbMarkup(component);
            thumb.dataset.twkHydrated='1';
          }
          var titleEl=card.querySelector('.cart-items__bundle-title');
          if(titleEl&&component.title){
            var nextTitle=String(component.title);
            if(titleEl.textContent!==nextTitle)titleEl.textContent=nextTitle;
          }
          var qtyEl=card.querySelector('.cart-items__bundle-qty');
          var qty=Number(component.quantity||component.qty||1);
          if(qtyEl){
            if(qty>1){
              var nextQty='Qty '+qty;
              if(qtyEl.textContent!==nextQty)qtyEl.textContent=nextQty;
              qtyEl.hidden=false;
            }else qtyEl.hidden=true;
          }
        });
      });
    }catch(error){
      console.warn('[TEWIKY Bundle Cart Line]',error);
    }
  }

  /* ---------- Complete the Look V0.3 — flat rail + isolated fast AJAX ---------- */
  function imageUrl(product){
    var img=product&&product.featured_image;
    if(img&&typeof img==='object')img=img.url||img.src;
    if(!img&&product&&product.images&&product.images[0]){
      img=typeof product.images[0]==='string'?product.images[0]:(product.images[0].url||product.images[0].src);
    }
    return img||'';
  }
  function availableVariants(product){
    return (product&&Array.isArray(product.variants)?product.variants:[]).filter(function(v){return v&&v.available!==false;});
  }
  function productUrl(product,variantId){
    var url=(product&&product.url)||('/products/'+encodeURIComponent(product&&product.handle||''));
    if(variantId)url+=(url.indexOf('?')>-1?'&':'?')+'variant='+encodeURIComponent(variantId);
    return url;
  }
  function comparePriceMarkup(variant,currency){
    var compare=Number(variant&&variant.compare_at_price||0);
    var price=Number(variant&&variant.price||0);
    if(compare>price)return '<s class="twk-ctl-card__compare">'+escapeHtml(money(compare,currency))+'</s>';
    return '';
  }
  function productCardHtml(product,currency){
    var variants=availableVariants(product);
    if(!variants.length)return '';
    var variant=variants[0];
    var img=imageUrl(product);
    var select='';
    if(variants.length>1){
      var firstVariantLabel=variant.public_title||variant.title||'Option';
      select='<div class="twk-ctl-select-shell">'+
        '<span class="twk-ctl-select-label" data-twk-ctl-select-label aria-hidden="true">'+escapeHtml(firstVariantLabel)+'</span>'+
        '<select class="twk-ctl-select" data-twk-ctl-select aria-label="Choose an option for '+escapeHtml(product.title)+'">'+variants.map(function(v){
          return '<option value="'+escapeHtml(v.id)+'" data-price="'+escapeHtml(v.price)+'" data-compare-at-price="'+escapeHtml(v.compare_at_price||0)+'">'+escapeHtml(v.public_title||v.title||'Option')+'</option>';
        }).join('')+'</select>'+
        '<span class="twk-ctl-select-chevron" aria-hidden="true"></span>'+
      '</div>';
    }
    var formId='TewikyDrawerAutoLook-'+String(product.id||Math.random()).replace(/[^a-zA-Z0-9_-]/g,'');
    var single=variants.length>1?'':' twk-ctl-form--single';
    return '<article class="twk-ctl-card" data-twk-ctl-card data-product-id="'+escapeHtml(product.id)+'">'+
      '<a class="twk-ctl-card__image" href="'+escapeHtml(productUrl(product,variant.id))+'" aria-label="'+escapeHtml(product.title)+'">'+
        (img?'<img src="'+escapeHtml(img)+'" loading="lazy" alt="'+escapeHtml(product.title)+'">':'')+
      '</a><div class="twk-ctl-card__body">'+
        '<div class="twk-ctl-card__top">'+
          '<a class="twk-ctl-card__title" href="'+escapeHtml(productUrl(product,variant.id))+'">'+escapeHtml(product.title)+'</a>'+
          '<div class="twk-ctl-card__price-wrap">'+comparePriceMarkup(variant,currency)+'<div class="twk-ctl-card__price" data-twk-ctl-price>'+escapeHtml(money(variant.price,currency))+'</div></div>'+
        '</div>'+
        '<form method="post" action="'+escapeHtml(rootUrl()+'cart/add')+'" id="'+escapeHtml(formId)+'" class="twk-ctl-form'+single+'" data-twk-ctl-ajax-form>'+
          '<input type="hidden" name="id" value="'+escapeHtml(variant.id)+'" data-twk-ctl-variant-id><input type="hidden" name="quantity" value="1">'+select+
          '<button type="submit" name="add" class="twk-ctl-add" data-twk-ctl-add><span class="twk-ctl-add__default">Add to Cart</span><span class="twk-ctl-add__loading" aria-hidden="true">Adding…</span><span class="twk-ctl-add__added" aria-hidden="true">Added ✓</span></button>'+
        '</form>'+
      '</div></article>';
  }

  function setCtlButtonState(button,state){
    if(!button)return;
    button.classList.remove('is-loading','is-added','is-error');
    if(state==='loading')button.classList.add('is-loading');
    if(state==='added')button.classList.add('is-added');
    if(state==='error')button.classList.add('is-error');
    button.disabled=state==='loading'||state==='added';
  }

  function updateCtlPriceForOption(card,option,currency){
    if(!card||!option)return;
    var price=card.querySelector('[data-twk-ctl-price]');
    var priceWrap=card.querySelector('.twk-ctl-card__price-wrap');
    var minor=Number(option.dataset.price||0);
    var compare=Number(option.dataset.compareAtPrice||0);
    if(price)price.textContent=money(minor,currency);
    if(priceWrap){
      var compareEl=priceWrap.querySelector('.twk-ctl-card__compare');
      if(compare>minor){
        if(!compareEl){
          compareEl=document.createElement('s');
          compareEl.className='twk-ctl-card__compare';
          priceWrap.insertBefore(compareEl,priceWrap.firstChild);
        }
        compareEl.textContent=money(compare,currency);
        compareEl.hidden=false;
      }else if(compareEl){
        compareEl.hidden=true;
      }
    }
  }

  async function submitCompleteLookForm(box,form){
    if(!form||form.dataset.twkBusy==='1')return;
    var button=form.querySelector('[data-twk-ctl-add]');
    form.dataset.twkBusy='1';
    setCtlButtonState(button,'loading');

    try{
      var formData=new FormData(form);
      formData.set('quantity',formData.get('quantity')||'1');
      formData.set('sections',getCartSectionIds().join(','));
      formData.set('sections_url',window.location.pathname+window.location.search);

      var response=await fetch(rootUrl()+'cart/add.js',{
        method:'POST',
        credentials:'same-origin',
        headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},
        body:formData
      });
      var payload=null;
      try{payload=await response.json();}catch(parseError){payload=null;}
      if(!response.ok){
        var message=(payload&&payload.description)||(payload&&payload.message)||'Unable to add item';
        throw new Error(message);
      }

      /* Immediate feedback first, then reuse the PROTECTED V7 cart bridge.
         The bridge consumes the fresh section HTML from /cart/add.js, so the
         open drawer updates without a second blocking cart request. */
      setCtlButtonState(button,'added');
      await nextPaint();
      await notifyAdd({
        source:'tewiky-complete-look',
        context:'product',
        sections:payload&&payload.sections||undefined,
        open:true
      });
    }catch(error){
      console.warn('[TEWIKY Complete the Look] Add failed',error);
      setCtlButtonState(button,'error');
      var defaultLabel=button&&button.querySelector('.twk-ctl-add__default');
      if(defaultLabel)defaultLabel.textContent='Try Again';
      window.setTimeout(function(){
        if(defaultLabel)defaultLabel.textContent='Add to Cart';
        if(button&&button.isConnected)setCtlButtonState(button,'idle');
      },1400);
    }finally{
      form.dataset.twkBusy='0';
      if(button&&button.isConnected&&button.classList.contains('is-added')){
        window.setTimeout(function(){
          if(button&&button.isConnected)setCtlButtonState(button,'idle');
        },1100);
      }
    }
  }

  function bindCompleteLook(box){
    if(!box||box.dataset.twkReady==='1')return;
    box.dataset.twkReady='1';
    var track=box.querySelector('[data-twk-ctl-track]');
    if(!track)return;
    var prev=box.querySelector('[data-twk-ctl-prev]');
    var next=box.querySelector('[data-twk-ctl-next]');
    function scroll(dir){
      var card=track.querySelector('[data-twk-ctl-card]');
      var amount=card?card.getBoundingClientRect().width+10:Math.max(240,track.clientWidth*.82);
      track.scrollBy({left:dir*amount,behavior:'smooth'});
    }
    if(prev)prev.addEventListener('click',function(){scroll(-1);});
    if(next)next.addEventListener('click',function(){scroll(1);});

    box.addEventListener('change',function(event){
      var select=event.target.closest&&event.target.closest('[data-twk-ctl-select]');
      if(!select)return;
      var card=select.closest('[data-twk-ctl-card]');
      var hidden=card&&card.querySelector('[data-twk-ctl-variant-id]');
      var option=select.options[select.selectedIndex];
      var label=select.closest('.twk-ctl-select-shell')&&select.closest('.twk-ctl-select-shell').querySelector('[data-twk-ctl-select-label]');
      if(hidden)hidden.value=select.value;
      if(label&&option)label.textContent=(option.textContent||option.label||'').trim();
      updateCtlPriceForOption(card,option,box.dataset.cartCurrency||'USD');
    });

    /* Capture phase prevents Horizon's product-form handler from racing this
       isolated drawer recommendation form. Other V7 add-to-cart entry points are untouched. */
    box.addEventListener('submit',function(event){
      var form=event.target.closest&&event.target.closest('[data-twk-ctl-ajax-form]');
      if(!form||!box.contains(form))return;
      event.preventDefault();
      event.stopPropagation();
      if(typeof event.stopImmediatePropagation==='function')event.stopImmediatePropagation();
      submitCompleteLookForm(box,form);
    },true);

    loadRecommendations(box,track);
  }

  async function fetchRecommendations(box,intent){
    var base=box.dataset.recommendationsUrl||'/recommendations/products';
    if(!/\.json(?:\?|$)/.test(base))base=base.replace(/\/$/,'')+'.json';
    var join=base.indexOf('?')>-1?'&':'?';
    var url=base+join+'product_id='+encodeURIComponent(box.dataset.sourceProductId||'')+'&limit=8&intent='+encodeURIComponent(intent);
    var response=await fetch(url,{credentials:'same-origin',headers:{Accept:'application/json'},cache:'no-store'});
    if(!response.ok)throw new Error('Recommendations unavailable');
    var data=await response.json();
    return Array.isArray(data&&data.products)?data.products:[];
  }

  async function loadRecommendations(box,track){
    var status=box.querySelector('[data-twk-ctl-status]');
    var existing=track.querySelectorAll('[data-twk-ctl-card]').length;
    if(existing>=4){if(status)status.hidden=true;return;}
    var excluded=new Set(String(box.dataset.cartProductIds||'').split(',').filter(Boolean));
    track.querySelectorAll('[data-product-id]').forEach(function(card){excluded.add(String(card.dataset.productId||''));});
    try{
      var products=await fetchRecommendations(box,'complementary');
      if(!products.length)products=await fetchRecommendations(box,'related');
      var currency=box.dataset.cartCurrency||'USD';
      products.forEach(function(product){
        if(track.querySelectorAll('[data-twk-ctl-card]').length>=6)return;
        if(!product||product.available===false||excluded.has(String(product.id)))return;
        var html=productCardHtml(product,currency);
        if(!html)return;
        track.insertAdjacentHTML('beforeend',html);
        excluded.add(String(product.id));
      });
    }catch(error){
      console.warn('[TEWIKY Complete the Look]',error);
    }finally{
      var count=track.querySelectorAll('[data-twk-ctl-card]').length;
      if(status)status.hidden=count>0;
      box.hidden=count===0;
    }
  }

  async function refreshAll(){
    updateGoal(document);
    attachHomepageBridge();
    document.querySelectorAll('[data-twk-complete-look]').forEach(bindCompleteLook);
    animateCartBadgeIfChanged();
    await hydrateBundleLines();
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){refreshAll();},{once:true});
  else refreshAll();
  document.addEventListener('shopify:section:load',function(){refreshAll();});

  var drawer=document.getElementById('cart-drawer');
  if(drawer&&window.MutationObserver){
    var queued=false;
    new MutationObserver(function(){
      if(queued)return;
      queued=true;
      requestAnimationFrame(function(){queued=false;refreshAll();});
    }).observe(drawer,{childList:true,subtree:true});
  }
})();
